import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { compose } from 'recompose';
import Icon from 'common/components/fa/Icon';
import { CreateLink } from '../list';
import dataProvider from '../dataProvider';
import SimulationTable from './SimulationTable';
import { withSession } from '../sessions';
import TitleLayout from '../layouts/sections/TitleLayout';

import './List.css';
import GridRadioButton from '../form/GridRadioButton';
import SimulationTopinvestTable from './SimulationTopinvestTable';

const SimulationListInner = ({ rip, session }) => {
    const [selectedView, setSelectedView] = useState('eripSimulations');

    return (
        <TitleLayout
            title="SIMULATION"
            className="title-layout"
        >
            {rip ? (
                <div>
                    <div className="container contract-mode-form">
                        <GridRadioButton
                            label="Simulations eRIP"
                            value="eripSimulations"
                            name="viewSelector"
                            checked={'eripSimulations' === selectedView}
                            onChange={() => setSelectedView('eripSimulations')}
                        />
                        <GridRadioButton
                            label="Simulations TopInvest"
                            value="topinvestSimulations"
                            name="viewSelector"
                            checked={'topinvestSimulations' === selectedView}
                            onChange={() => setSelectedView('topinvestSimulations')}
                            disabled={!session.userHasTopInvestAccess}
                        />
                    </div>
                    {'eripSimulations' === selectedView ? (
                        <SimulationTable session={session} rip={rip} />
                    ) : (
                        <SimulationTopinvestTable session={session} rip={rip} />
                    )}
                    <CreateLink to={`/rip/${rip.id}/simulations/new`} />
                    {session.permissions.mayCreateContract() && (
                        <Link className="list-export-button second" to={`/rip/${rip.id}/contracts`}>
                            <Icon icon="handshake-o" />
                        </Link>
                    )}
                </div>
            ) : null}
        </TitleLayout>
    );
};

SimulationListInner.propTypes = {
    rip: PropTypes.shape({
        id: PropTypes.string,
    }),
    session: PropTypes.shape({
        permissions: PropTypes.shape({
            mayCreateContract: PropTypes.func,
        }),
        userHasTopInvestAccess: PropTypes.bool,
    }),
};

SimulationListInner.defaultProps = {
    rip: null,
};

const SimulationList = compose(
    withSession,
    dataProvider({
        id: ({ params: { id } }) => id,
        type: 'rip',
        wait: true,
    }),
)(SimulationListInner);

export default SimulationList;
